/* eslint-disable camelcase */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { Table, Input, Row, Col } from "antd";

import IntlMessages from "util/IntlMessages";
import moment from "moment";
import { getGatewayTransactions } from "../../../redux/actions/Gateway";
import generateQuery, { handleSearch as search } from "../../../util/table";
import PageLimitSwitch from "../../../components/PageLimitSwitch";

const columns = [
  {
    title: "Created",
    dataIndex: "created_at",
    search: false,
    render: (date) => <span>{moment(date).format("DD/MM/YY h:mm:ss a")}</span>,
    sorter: true,
  },
  {
    title: "P/R",
    dataIndex: "kitegateway_reference",
    sorter: true,
    width: 200,
  },
  {
    title: "  Ip address",
    dataIndex: "ip_address",
    sorter: true,
    width: 200,
  },
  {
    title: "Level",
    dataIndex: "level",
    sorter: true,
  },
  {
    title: "Message",
    dataIndex: "message",
    sorter: true,
  },
  {
    title: "Service Type",
    dataIndex: "service_type",
    sorter: true,
  },
  {
    title: "Processor name",
    dataIndex: "processor_name",
    sorter: true,
    width: 150,
  },
  {
    title: "Processor Reference",
    dataIndex: "processor_reference",
    sorter: true,
  },
  {
    title: "Url",
    dataIndex: "url",
    sorter: true,
  },
];

const TransactionLogs = () => {
  const dispatch = useDispatch();
  const history = useHistory();
  const { data, pageSize, currentPage, totalRecords, loading } = useSelector(
    ({ gateway }) => gateway.gateway_transactions
  );
  const [searchParams, setSearchParams] = useState("");

  useEffect(() => {
    const pagination = `page=${currentPage}&limit=${pageSize}`;
    dispatch(getGatewayTransactions(pagination));
  }, [dispatch, pageSize, currentPage]);

  // eslint-disable-next-line max-len
  const dataSource = data?.map(
    ({
      _id,
      created_at,
      ip_address,
      level,
      message,
      kitegateway_reference,
      service_type,
      processor_name,
      processor_reference,
      url,
    }) => ({
      key: _id,
      created_at,
      ip_address,
      level,
      message,
      kitegateway_reference,
      service_type,
      processor_name,
      processor_reference,
      url,
    })
  );

  const handleOnChange = (pagination, filters, sorter) => {
    dispatch(
      getGatewayTransactions(
        generateQuery(pagination, filters, sorter, searchParams)
      )
    );
  };

  const handleSearch = (searchValue) => {
    const query = search(
      searchValue,
      dispatch,
      getGatewayTransactions,
      columns
    );
    setSearchParams(query);
  };

  const navigateToView = (record) => ({
    onClick: () => {
      history.push(`/gateway-transactions/${record.key}`);
    },
  });

  const props = {
    pagination: false,
    onRow: navigateToView,
    onChange: handleOnChange,
    loading,
    columns,
    dataSource,
  };

  return (
    <div>
      <h2 className="title gx-mb-4">
        <IntlMessages id="transaction_logs.title" />
      </h2>
      <div className="gx-d-flex justify-content-center">
        <Input.Search
          placeholder="Search Transactions"
          enterButton
          allowClear
          onSearch={handleSearch}
        />
      </div>
      <div className="gx-d-flex justify-content-center">
        <Table className="gx-table-responsive striped-table" {...props} />
      </div>
      <Row className="pagination">
        <Col md={12}>
          <PageLimitSwitch
            resourceType="gateway_transactions"
            limit={pageSize}
            limits={[10, 100, 200, 500, 1000, 2000, 5000, 10000]}
            totalRecords={totalRecords}
            currentPage={currentPage}
          />
        </Col>
      </Row>
    </div>
  );
};

export default TransactionLogs;
